import CelebrateScatterCommand from "commands/celebrate-scatter-command";
import { DimSymbolsCommand } from "slotworks/commands/symbols/dim-symbols-command";
import Components from "slotworks/components/components";
import Layers from "slotworks/graphics/layers/layers";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { sequence } from "slotworks/utils/race-utils";

export default class HarleyFreespinsRetrigger extends State {

    public onEnter() {
        smartButton.setFlag(SmartButtonFlag.PROMPT, true);
        const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

        const contents = new Map<string, string>();

        contents.set("value", record.freespinsWon.toString());
        sequence([
            () => DimSymbolsCommand(Components.matrix.getGridSymbols()),
            () => CelebrateScatterCommand(),
            () => Contract.getTimeoutContract(20),
            () => Layers.CelebrationBackground.setScene("retrigger"),
            () => Components.prompt.show(["retrigger"], contents, 1000),
            () => Layers.CelebrationBackground.defaultScene(),
            () => Contract.getTimeoutContract(200),
        ]).then(() => this.complete());
    }

    public complete() {
        smartButton.setFlag(SmartButtonFlag.PROMPT, false);

        // new BetMenuFreespinsMediator().start().execute();

        super.complete();
    }

}